import getUmbracoEndPoint from "app/umbraco/helpers/UmbracoEndPoint";
import urlBuilder from "app/umbraco/helpers/urlBuilder";

export default async (venueId?: string): Promise<any> => {
    
    if (sessionStorage.getItem("venueId") !== null && sessionStorage.getItem("venueId") === venueId && sessionStorage.getItem("openinghHours") !== null) {
        return {
                status: 200,
            ... JSON.parse(sessionStorage.getItem("openinghHours") || "{}")
        };
    }
    
    const url = urlBuilder(`/api/openinghours/${venueId}`, { });
    const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Origin": getUmbracoEndPoint(),
            "X-Request-Domain": getUmbracoEndPoint()
        },
        body: undefined
    });

    if (response.status === 200) {
        const result =  await response.json();
        sessionStorage.setItem("venueId", venueId || "");
        sessionStorage.setItem("openinghHours", JSON.stringify(result));
        return {...result, status: response.status}
    }
    else {
        return new Promise<any>((resolve) => {
            return resolve({
                status: response.status
            });
        });
    }
};